import "./App.css";
import { AuthContext } from "./utils/AuthContext";
import { useMemo, useState } from "react";
import Configuration from "./layout/Configuration";
import { TokenContext } from "./utils/TokenContext";


function App() {
  const [user, setUser] = useState(null);
  const userValue = useMemo(() => ({ user, setUser }), [user, setUser]);

  const [token, setToken] = useState(null);
  const tokenValue = useMemo(() => ({ token, setToken }), [token, setToken]);

  return (
    <>
      <AuthContext.Provider value={userValue}>
        <TokenContext.Provider value={tokenValue}>
          <Configuration />
        </TokenContext.Provider>
      </AuthContext.Provider>
    </>
  );
}

export default App;
